import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";

library.add(fas);

export const clinicMenus = [
  {
    menu_id: 1,
    title: "Dashboard",
    icon: "fa fa-chart-pie",
    path: "/dashboard",
  },
  {
    menu_id: 2,
    title: "Dr. Round",
    icon: "fa fa-user-md",
    path: "/dr-round",
  },
  {
    menu_id: 3,
    title: "OT Note",
    icon: "fa fa-procedures",
    path: "/ot-note",
  },
  {
    menu_id: 4,
    title: "Discharge Summary",
    icon: "fa fa-file-medical",
    path: "/discharge-summary",
  },
  {
    menu_id: 5,
    title: "Medical Records",
    icon: "fa fa-folder-open",
    path: "/medical-records",
  },
  {
    menu_id: 6,
    title: "Pathology Result Approval",
    icon: "fa fa-microscope",
    path: "/pathology-result-approval",
  },
  {
    menu_id: 7,
    title: "Purchase Order Approval",
    icon: "fa fa-file-invoice",
    path: "/purchase-order-approval",
  },
  {
    menu_id: 8,
    title: "Intake Output Chart",
    icon: "fa fa-chart-line",
    path: "/intake-output-chart",
  },
  {
    menu_id: 9,
    title: "TPR",
    icon: "fa fa-heartbeat",
    path: "/tpr",
  },
  {
    menu_id: 10,
    title: "Nursing Notes",
    icon: "fa fa-user-nurse",
    path: "/nursing-notes",
  },
  {
    menu_id: 11,
    title: "RMO Notes",
    icon: "fa fa-stethoscope",
    path: "/rmo-notes",
  },
];

const MenuItem = ({ node, isDrawerOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = location.pathname === node.path;

  const [prefix, iconName] = node.icon.split(" ");
  const iconPrefix = prefix === "fa" ? "fas" : prefix;

  return (
    <div className="w-full">
      <motion.div
        className={`flex items-center w-full ${
          isDrawerOpen ? "p-4" : "p-0"
        } rounded-lg cursor-pointer transition-all duration-300 ease-in-out transform ${
          isActive
            ? "bg-[#E9F5FE] border border-[#217E90]"
            : "hover:bg-[#E9F5FE]"
        }`}
        style={{
          paddingLeft: isDrawerOpen ? "16px" : "0px",
          justifyContent: isDrawerOpen ? "flex-start" : "center",
        }}
        onClick={() => navigate(node.path)}
        whileHover={{ scale: 1.02 }}
        transition={{ duration: 0.2, ease: "easeInOut" }}
      >
        <motion.div
          className={`flex justify-center items-center transition-all duration-300 ${
            isDrawerOpen
              ? "text-xl"
              : "rounded-lg justify-center items-center p-7"
          }`}
          style={{
            width: isDrawerOpen ? "auto" : "2rem",
            height: isDrawerOpen ? "auto" : "2rem",
            borderRadius: isDrawerOpen ? "0" : "12px",
            color: isActive ? "#217E90" : "#7D8592",
          }}
        >
          <FontAwesomeIcon icon={[iconPrefix, iconName]} />
        </motion.div>
        {isDrawerOpen && (
          <motion.div
            className="ml-4 font-medium text-sm transition-opacity duration-300 ease-in-out"
            style={{
              color: isActive ? "#217E90" : "#7D8592",
              whiteSpace: "nowrap",
            }}
            initial={{ opacity: 0, width: 0 }}
            animate={{ opacity: 1, width: "auto" }}
            transition={{ duration: 0.3, ease: "easeInOut", delay: 0.2 }}
          >
            {node.title}
          </motion.div>
        )}
      </motion.div>
    </div>
  );
};

const MenuList = ({ isDrawerOpen }) => {
  return (
    <motion.div
      className={`p-2 relative flex flex-col bg-[#E9F5FE] shadow-lg h-full transition-all duration-300 ease-in-out overflow-x-hidden ${
        isDrawerOpen ? "w-72" : "w-32"
      }`}
      initial={{ width: isDrawerOpen ? "18rem" : "8rem" }}
      animate={{ width: isDrawerOpen ? "18rem" : "8rem" }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
    >
      <div className="flex h-full min-h-0 flex-col border border-[#217E90] rounded-2xl bg-white p-4">
        <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden pr-3 -mr-3">
          <div className="flex flex-col items-center space-y-1">
            {clinicMenus.map((node) => (
              <MenuItem key={node.menu_id} node={node} isDrawerOpen={isDrawerOpen} />
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default MenuList;
